import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    template: '',
})
export class UBXFieldBase {
    @Input() model: any;
    @Output() modelChange: EventEmitter<any> = new EventEmitter();
}
